/* 予約フォーム（Googleフォーム）への受け渡し。
   味ごとの本数を選ぶと合計が出て、ボタンを押すと数量と会員情報が入った状態でフォームが開く。
   会員でない人の分は空欄のまま開く（入力は本人がする）。 */
(function () {
  function init(root) {
    if (root.dataset.w99PreorderReady === '1') return;
    root.dataset.w99PreorderReady = '1';

    var cfg;
    try { cfg = JSON.parse(root.dataset.config || '{}'); } catch (e) { return; }
    if (!cfg.base) return;

    var selects = root.querySelectorAll('[data-preorder-qty]');
    var totalEl = root.querySelector('[data-preorder-total]');
    var goEl = root.querySelector('[data-preorder-go]');
    var warnEl = root.querySelector('[data-preorder-warn]');
    if (!goEl) return;

    function build() {
      var total = 0;
      var params = [];
      for (var i = 0; i < selects.length; i++) {
        var s = selects[i];
        var n = parseInt(s.value, 10);
        if (!n || n < 1) continue;
        total += n;
        var entry = (cfg.variants || {})[s.dataset.variantId];
        if (entry) params.push(encodeURIComponent(entry) + '=' + encodeURIComponent(String(n)));
      }
      var who = {};
      who[cfg.name] = root.dataset.customerName || '';
      who[cfg.email] = root.dataset.customerEmail || '';
      who[cfg.phone] = root.dataset.customerPhone || '';
      for (var k in who) {
        if (!k || k === 'undefined' || !who[k]) continue;
        params.push(encodeURIComponent(k) + '=' + encodeURIComponent(who[k]));
      }
      if (totalEl) totalEl.textContent = String(total);
      if (warnEl) warnEl.hidden = total > 0;
      goEl.setAttribute('aria-disabled', total > 0 ? 'false' : 'true');
      var sep = cfg.base.indexOf('?') === -1 ? '?' : '&';
      goEl.href = cfg.base + sep + 'usp=pp_url' + (params.length ? '&' + params.join('&') : '');
      root.dataset.total = String(total);
    }

    for (var i = 0; i < selects.length; i++) selects[i].addEventListener('change', build);
    goEl.addEventListener('click', function (ev) {
      if (parseInt(root.dataset.total || '0', 10) > 0) return;
      ev.preventDefault();
      if (warnEl) { warnEl.hidden = false; warnEl.focus && warnEl.focus(); }
    });
    build();
  }

  function scan() {
    var list = document.querySelectorAll('[data-preorder]');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();